import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSignedUrlEpochStore = defineStore('signedUrlEpoch', () => {
  const signedUrlEpoch = ref(0);

  function bumpSignedUrlEpoch() {
    signedUrlEpoch.value += 1;
  }

  return {
    signedUrlEpoch,
    bumpSignedUrlEpoch,
  };
});
